<template>
  <div class="kpt-home-grid" style="height: 100%">
    <vue-headful title="Home" />
    <div class="kpt-home-overview">
      <OverviewTilesComponent />
      
      <div class="card mt-4"> <!-- Recent Terminals -->
        <RecentTerminalsComponent />
      </div>
    </div>
    <div class="kpt-home-map">
      <div class="card is-flex-grow-1">
        <TerminalMap :terminals="terminals" :terminals-loading="loadingTerminals" :online-only="onlineOnly" />
      </div>
      <div class="card mt-4">
        <MarketingBox />
      </div>
    </div>
  </div>
</template>
<script setup>
import { ref, onMounted } from 'vue';
import TerminalMap from './components/v3/TerminalMap.vue';
import { useTerminalsStore } from '../terminals/terminals-store';
import OverviewTilesComponent from './components/v3/OverviewTilesComponent.vue';
import RecentTerminalsComponent from './components/v3/RecentTerminalsComponent.vue';
import MarketingBox from './components/v3/MarketingBox.vue';

const terminals = ref([]);
const loadingTerminals = ref(false);
const onlineOnly = ref(true);
const terminalsStore = useTerminalsStore();

const loadTerminals = async () => {
  loadingTerminals.value = true;
  const result = await terminalsStore.dispatch('fetchTerminals', { 
    skip: 0,
    take: 10000, 
    sortField: 'Name', 
    sortDirection: 'ASC',
    fields: 'Id,Name,Serial,NetworkStatus,Location',
    filters: 'NetworkStatus.SatelliteOnline:true',
    skipCommit: true
  });
  terminals.value = result.items;
  loadingTerminals.value = false;
}

onMounted(async () => {
  await loadTerminals();
})

</script>
<style lang="scss">
@import '../styles/colors';
.kpt-home-grid {
  display: grid;
  grid-template-columns: minmax(300px, 25%) 1fr;

  @media(max-width: 1450px) {
    grid-template-columns: minmax(300px, 33%) 1fr;
  }
  background: $white-bis;
  
  .kpt-home-overview {
    padding: 1em;
  }

  .kpt-home-map {
    padding: 1rem;
    padding-left: 0;
    display: flex;
    flex-direction: column;
  }
}
.kpt-media-icon{
  width:40px;
}
</style>
